import { createRoot } from 'react-dom/client'
import { AndrzejWidget } from '../components/andrzej/AndrzejWidget'
import { ErrorBoundary } from '../components/ui/ErrorBoundary'
import '../styles/application.css'

const el = document.getElementById('andrzej-root')
if (el) {
  createRoot(el).render(<ErrorBoundary fallback={null}><AndrzejWidget /></ErrorBoundary>)
}
